module.exports = __webpack_public_path__ + "static/media/AVAX.332188f0.svg";